import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (bg, label) =>
  L.divIcon({
    className: "",
    html: `<div style="background:${bg};color:#fff;font:700 10px Arial,sans-serif;padding:4px 8px;border-radius:999px;box-shadow:0 2px 8px rgba(0,0,0,.25);white-space:nowrap">${label}</div>`,
    iconSize: [70, 22],
    iconAnchor: [35, 11],
  });
const SHOP = pin("#0f172a", "SHOP");
const HOME = pin("#059669", "YOU");
const RIDER = pin("#f59e0b", "RIDER");

function FitBounds({ points }) {
  const map = useMap();
  const key = points.map((p) => p.join(",")).join("|");
  useEffect(() => {
    if (points.length > 1) map.fitBounds(points, { padding: [40, 40], maxZoom: 16 });
    else if (points.length === 1) map.setView(points[0], 15);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export default function LiveTrackMap({ order }) {
  const shop = order.shop_lat != null ? [order.shop_lat, order.shop_lng] : null;
  const drop = order.drop_lat != null ? [order.drop_lat, order.drop_lng] : null;
  const rider = order.rider_lat != null ? [order.rider_lat, order.rider_lng] : null;
  const points = [shop, drop, rider].filter(Boolean);
  if (points.length === 0) return null;
  return (
    <div className="mt-6 rounded-2xl overflow-hidden border border-slate-200 h-64 relative z-0" data-testid="live-track-map">
      <MapContainer center={points[0]} zoom={14} scrollWheelZoom={false} className="h-full w-full">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {shop && <Marker position={shop} icon={SHOP}><Popup>{order.shop_name}</Popup></Marker>}
        {drop && <Marker position={drop} icon={HOME}><Popup>Delivery address</Popup></Marker>}
        {rider && <Marker position={rider} icon={RIDER}><Popup>{order.rider_name || "Your rider"}</Popup></Marker>}
        <FitBounds points={points} />
      </MapContainer>
    </div>
  );
}
